// Import DataTables
import DataTable from 'datatables.net-dt';
import 'datatables.net-responsive-dt';

// Make DataTables globally accessible
window.DataTable = DataTable;